import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';

interface MarkCompanyAiReceptionistCallAsReadPayload {
  company_id: string;
  call_id: string;
}

export async function markCompanyAiReceptionistCallAsRead(
  payload: MarkCompanyAiReceptionistCallAsReadPayload,
  auth: Authentication,
): Promise<void> {
  try {
    if (!payload.company_id || !payload.call_id) {
      throw new MarkCompanyAiReceptionistCallAsReadFailure('company_id et call_id sont requis');
    }

    await HttpClient.post('/company/ai-receptionist/calls/read', payload, auth.token);
  } catch (e) {
    console.error('markCompanyAiReceptionistCallAsRead error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new MarkCompanyAiReceptionistCallAsReadFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new MarkCompanyAiReceptionistCallAsReadFailure(e.message);
    }
    return Promise.reject(e);
  }
}

export class MarkCompanyAiReceptionistCallAsReadFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}
